export class LoadDemo {
    static readonly type = '[Demo] Load demos';

    constructor(public payload: { id: string }) {}
}

export class LoadDemos {
    static readonly type = '[Demo] Load all demos';
}

export class LoadCustomDemo {
    static readonly type = '[Demo] Load custom demo';
}
